import axios from 'axios';
import envService from '@/services/env.service';

const BASE_URL = envService.getApiBaseUrl() + '/sms/stats';

export default {

    getStatistics(webId, months, email) {
        return axios.get(BASE_URL + '/' + webId + "/" + months, {
            headers: {
                'X-User-Email': email,
            },
        }) 
    }
}